/**
 * Shared markdown renderer (react-markdown + GFM). Used wherever the agent or a
 * supplier message is shown so **bold**, lists, headings etc. render instead of
 * showing raw asterisks. Pair with the `.md-tight` class (App.css) inside chat
 * bubbles to keep spacing compact.
 */
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const Markdown = ({ children, className = 'md-tight' }) => (
  <div className={className}>
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        // open any links the agent/supplier includes in a new tab
        a: ({ node, ...props }) => <a target="_blank" rel="noreferrer" {...props} />,
        // shared images (attachments) render inline but capped to the bubble width
        img: ({ node, ...props }) => (
          <img {...props} alt={props.alt || ''} loading="lazy"
               style={{ maxWidth: '100%', maxHeight: 320, borderRadius: 8, display: 'block', margin: '4px 0' }} />
        ),
      }}
    >
      {children || ''}
    </ReactMarkdown>
  </div>
);

export default Markdown;
